import React from 'react';

import {ThemeProvider} from '@mui/material';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import GitInfo from 'react-git-info/macro';
import {I18nextProvider} from 'react-i18next';
import {Provider} from 'react-redux';

import {config} from 'config/env/index';
import i18n from 'config/i18n/i18n';
import {DefaultThemeOptions} from 'config/theme';
import {AnalyticsContextProvider} from 'contexts/analytics-context';
import {store} from 'store';
import ErrorBoundary from 'views/error-boundary/ErrorBoundary';

import App from './App';
import './index.css';
import {getVersion} from './utils/version';

Sentry.init({
  dsn: config.SENTRY_DSN,
  environment: config.SENTRY_ENV,
  integrations: [],
  sampleRate: 1.0,
  release: `${GitInfo().tags?.length ? GitInfo().tags.join(',') : ''}`
});

const version = getVersion();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

version
  ? root.render(version)
  : root.render(
      <ErrorBoundary>
        <ThemeProvider theme={DefaultThemeOptions}>
          <I18nextProvider i18n={i18n}>
            <AnalyticsContextProvider>
              <Provider store={store}>
                <App />
              </Provider>
            </AnalyticsContextProvider>
          </I18nextProvider>
        </ThemeProvider>
      </ErrorBoundary>
    );
